// icons/rv.svg

export const RVIconV2 = (props) => (
  <svg
    className={props.className}
    width="35"
    height="24"
    viewBox="0 0 35 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_24_2)">
      <path
        d="M15 11.25C15.6904 11.25 16.25 10.6904 16.25 10C16.25 9.30965 15.6904 8.75 15 8.75H6.25C5.55965 8.75 5 9.30965 5 10C5 10.6904 5.55965 11.25 6.25 11.25H15Z"
        fill="#25272C"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.75 20H6.2943C6.59757 22.1201 8.42095 23.75 10.625 23.75C12.829 23.75 14.6524 22.1201 14.9557 20H22.5443C22.8476 22.1201 24.671 23.75 26.875 23.75C29.079 23.75 30.9024 22.1201 31.2057 20H31.25C33.3211 20 35 18.3211 35 16.25V13.75C35 11.6789 33.3211 10 31.25 10H30.669L29.4834 8.22156C30.9856 7.31964 31.7586 5.40582 31.0392 3.60729L30.5393 2.35729C29.9698 0.933566 28.5908 0 27.0574 0H17.7951C16.3748 0 15.0763 0.802509 14.441 2.07295L14.2275 2.5H3.75C1.67894 2.5 0 4.17894 0 6.25V16.25C0 18.3211 1.67894 20 3.75 20ZM17.7951 2.5C17.3216 2.5 16.8888 2.7675 16.677 3.19099L16.118 4.30901C15.9062 4.7325 15.4735 5 15 5H3.75C3.05965 5 2.5 5.55965 2.5 6.25V16.25C2.5 16.9404 3.05965 17.5 3.75 17.5H6.67103C7.37319 16.0219 8.87975 15 10.625 15C12.3702 15 13.8769 16.0219 14.579 17.5H22.921C23.6231 16.0219 25.1298 15 26.875 15C28.6202 15 30.1269 16.0219 30.829 17.5H31.25C31.9404 17.5 32.5 16.9404 32.5 16.25V13.75C32.5 13.0596 31.9404 12.5 31.25 12.5H22.5C21.8096 12.5 21.25 11.9404 21.25 11.25V7.5C21.25 6.80965 21.8096 6.25 22.5 6.25H27.5574C28.4418 6.25 29.0465 5.35684 28.718 4.53576L28.218 3.28576C28.0281 2.81119 27.5685 2.5 27.0574 2.5H17.7951ZM26.831 8.75L27.6644 10H23.75V8.75H26.831ZM25 19.375C25 18.3395 25.8395 17.5 26.875 17.5C27.9105 17.5 28.75 18.3395 28.75 19.375C28.75 20.4105 27.9105 21.25 26.875 21.25C25.8395 21.25 25 20.4105 25 19.375ZM10.625 17.5C9.58946 17.5 8.75 18.3395 8.75 19.375C8.75 20.4105 9.58946 21.25 10.625 21.25C11.6605 21.25 12.5 20.4105 12.5 19.375C12.5 18.3395 11.6605 17.5 10.625 17.5Z"
        fill="#25272C"
      />
    </g>
  </svg>
);
